<template>
  <div v-if="!isLoadingInit">
    <!-- <b-row>
      <b-col class="mx-auto" cols="12" sm="10" md="8">
        <b-alert variant="warning" show
          >In order to add guests you need to have internet connection.</b-alert
        >
      </b-col>
    </b-row> -->
    <b-row>
      <b-col class="mx-auto" cols="12" sm="10" md="8">
        <!-- action create new, select groups -->
        <div class="mt-2 mb-4">
          <b-button class="button agv-button btn-blue" @click="addPressed">
            <font-awesome-icon icon="plus" size="1x" />
            <span class="agv-button-text">
              Ajouter des invites
            </span>
          </b-button>
        </div>
        <appMeetingGuest
          v-if="viewAdd"
          :is-new="true"
          :meeting-id="meetingId"
          @cancel="cancelPressed"
        />
        <appMeetingGuest
          v-else-if="viewEdit"
          :is-new="false"
          :meeting-id="meetingId"
          @cancel="cancelPressed"
        />
        <appMeetingGuestsTable
          v-else
          ref="mr-table"
          class="agv-table"
          :items="guests"
          :meeting-id="meetingId"
          @editPressed="editPressed"
        />
      </b-col>
    </b-row>
  </div>
  <appLoader v-else />
</template>

<script>
import appResolution from "@/components/catalogs/resolutions/Resolution";

import MeetingGuestMW from "@/middlewares/MeetingGuest";
import MeetingGuestORM from "@/store/orm-axios/models/MeetingGuest";

export default {
  components: {
    appMeetingGuestsTable: () => import("@/components/meeting-guest/MeetingGuestsTable"),
    appMeetingGuest: () => import("@/components/meeting-guest/MeetingGuest"),
  },
  props: {
    meetingId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      tableData: [],
      //???:
      viewAdd: false,
      viewEdit: false,
      meetingResolutionId: null,
      isLoadingInit: true,
    };
  },
  computed: {
    guests() {
      var meetingGuests = MeetingGuestORM.query().where("meeting_id", this.meetingId).get();

      return meetingGuests.map(mg => {
        return {
          ...mg,
          showPassword: false,
        };
      });
    },
  },
  watch: {
    viewAdd(val) {
      this.$emit("hideParentActionButtons", val);
    },
    viewEdit(val) {
      this.$emit("hideParentActionButtons", val);
    },
  },
  async created() {
    await MeetingGuestMW.FETCH(this.meetingId);
    this.isLoadingInit = false;
  },
  beforeDestroy() {
    this.tableData = null;
    this.$emit("hideParentActionButtons", false);
    MeetingGuestORM.deleteAll();
  },
  methods: {
    addPressed() {
      this.viewAdd = true;
    },
    editPressed(e) {
      this.meetingGuest = e.id;
      this.viewEdit = true;
    },
    goToMeetingPresence() {
      this.$router.push({ name: "meeting-presence" });
    },
    cancelPressed() {
      this.viewAdd = false;
      this.viewEdit = false;
      this.meetingGuest = null;
    },
  },
};
</script>
